import { io } from 'socket.io-client'
const { socketUrl, socketDomain: path } = require('@/settings')

const socket = io(socketUrl, {
  path,
  autoConnect: true,
  transports: ['websocket', 'polling']
})

const authSocket = io(`${socketUrl}/authentication`, {
  path,
  withCredentials: true,
  autoConnect: true,
  transports: ['websocket', 'polling']
})

export { socket, authSocket }
